<template>
  <div class="workbench-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>社区民生诉求工作台</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="stat-card stat-pending">
            <div class="stat-value">{{ stats.pendingCount || 0 }}</div>
            <div class="stat-label">待回复诉求</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card stat-today">
            <div class="stat-value">{{ stats.todayNewCount || 0 }}</div>
            <div class="stat-label">今日新增</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card stat-replied">
            <div class="stat-value">{{ stats.todayRepliedCount || 0 }}</div>
            <div class="stat-label">今日已回复</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card stat-cancel">
            <div class="stat-value">{{ stats.cancelApplyingCount || 0 }}</div>
            <div class="stat-label">撤销申请中</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!--
    <el-card>
      <div slot="header" class="clearfix">
        <span>快捷入口</span>
      </div>
      <el-row :gutter="20">
        <el-col v-for="(item, index) in quickEntries" :key="index" :span="4">
          <div class="quick-card" @click="goTo(item.path)">
            <i :class="item.icon" class="quick-icon" />
            <div class="quick-label">{{ item.label }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    -->

    <area-appeal-list-panel />
  </div>
</template>

<script>
import { queryAreaAppealIndex } from '@/api/community/areaAppealApi'
import AreaAppealListPanel from './AreaAppealListPanel.vue'

export default {
  name: 'AreaWorkbench',
  components: {
    AreaAppealListPanel
  },
  data() {
    return {
      stats: {
        pendingCount: 0,
        todayNewCount: 0,
        todayRepliedCount: 0,
        cancelApplyingCount: 0
      },
      quickEntries: [
        { label: '诉求管理', path: '/pages/areaAppealList', icon: 'el-icon-s-order' },
        { label: '分类管理', path: '/pages/areaAppealTypeList', icon: 'el-icon-s-grid' },
        { label: '社区管理', path: '/pages/areaList', icon: 'el-icon-office-building' },
        { label: '小区绑定', path: '/pages/areaCommunityBind', icon: 'el-icon-house' },
        { label: '人员绑定', path: '/pages/areaStaffBind', icon: 'el-icon-user' }
      ]
    }
  },
  created() {
    this.loadStats()
  },
  methods: {
    loadStats() {
      queryAreaAppealIndex({}).then(data => {
        this.stats = data || {}
      }).catch(error => {
        this.$message.error(error.message || '获取统计数据失败')
      })
    },
    goTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.workbench-container {
  padding: 20px;

  .el-card {
    margin-bottom: 20px;
  }

  .stat-card {
    padding: 20px;
    border-radius: 8px;
    color: #fff;
    text-align: center;

    .stat-value {
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .stat-label {
      font-size: 14px;
    }
  }

  .stat-pending {
    background: linear-gradient(135deg, #f56c6c, #e6a23c);
  }

  .stat-today {
    background: linear-gradient(135deg, #409eff, #36a3f7);
  }

  .stat-replied {
    background: linear-gradient(135deg, #67c23a, #85ce61);
  }

  .stat-cancel {
    background: linear-gradient(135deg, #909399, #c0c4cc);
  }

  .quick-card {
    height: 120px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-color: #409eff;
      color: #409eff;
    }

    .quick-icon {
      font-size: 32px;
      margin-bottom: 10px;
    }

    .quick-label {
      font-size: 14px;
    }
  }
}
</style>
